<template>
    <div class="p-fluid">
        <div class="formgrid grid">
            <div class="field col-12 md:col-6 lg:col-4">
                <label>User</label>
                <Listbox ref="duser" v-model="forms.mcu_id" :options="dataDropdownUser"
                    :class="{ 'p-invalid': errorAdd.mcu_id }" :multiple="true" :filter="true" optionLabel="label"
                    listStyle="max-height:300px" @filter="searchDropdownUser($event, 'add')">
                    <template #option="slotProps">
                        <div>{{ slotProps.option.label }}</div>
                    </template>
                </Listbox>
                <small class="p-invalid" style="color: red" v-if="errorAdd.mcu_id">{{
                    errorAdd.mcu_id[0]
                }}</small>
            </div>
            <div class="field col-12 md:col-6 lg:col-8" v-if="convertMultiSelectUser(forms.mcu_id).length != 0">
                <div class="card" style="height: calc(60vh - 143px)">
                    <DataTable :value="forms.mcu_id" :scrollable="true" scrollHeight="flex">
                        <Column field="label" header="User">
                            <template #body="slotProps">
                                {{ slotProps.data.label }}
                            </template>
                        </Column>
                    </DataTable>
                </div>
            </div>
        </div>

        <div class="formgrid grid">
            <div class="col-12 flex justify-end gap-2">
                <Button label="Batal" icon="pi pi-times" class="p-button-secondary" :loading="loading"
                    @click="handleCancel" />
                <Button label="Simpan" icon="pi pi-check" class="p-button-primary" :loading="loading" @click="update" />
            </div>
        </div>

    </div>

</template>

<script>

import { mapGetters } from "vuex";

export default {
    emits: ["submit"],
    props: {
        item: {}
    },
    data() {
        return {
            // loading
            loading: false,
            loadingDropdownUser: false,

            // dataDropdown
            dataDropdownUser: null,

            // addNew
            forms: {
                mcu_id: [],
                region_id: null
            },
        }
    },
    mounted() {
        this.$store.commit('setErrorAdd', {});
        this.forms = this.item;
    },
    created() {
        this.searchDropdownUser("");
    },
    computed: {
        ...mapGetters(['errorAdd']),
        ...mapGetters("auth", ["user"]),
    },
    methods: {
        convertMultiSelectUser(data) {
            if (data) {
                return data.map((item) => {
                    return item.mcu_id;
                });
            } else {
                return [];
            }
        },
        // DROPDOWN
        searchDropdownUser(event, purpose, valueEdit) {
            setTimeout(() => {

                if (valueEdit) {
                    this.$refs.duser.filterValue = valueEdit;
                }

                if (purpose == "add") {
                    this.loadingDropdownUser = true;
                }

                this.axios({
                    method: 'GET',
                    url: process.env.VUE_APP_ROOT_API + 'web/select2/user-distributor-mcu',
                    params: {
                        "search": valueEdit ? valueEdit : event.value,
                        "region_id": this.forms.region_id,
                        "distributor_id": this.forms.distributor_id
                    }
                })
                    .then(res => {

                        if (purpose == "add") {
                            this.dataDropdownUser = res.data.data;
                            this.loadingDropdownUser = false;
                        } else if (purpose == null) {
                            this.dataDropdownUser = res.data.data;
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                    });

            }, 250);
        },
        // ADDNEW
        update() {
            this.loading = true;

            const data = {
                ...this.forms,
                mcu_id: this.convertMultiSelectUser(this.forms.mcu_id)
            };

            this.axios({
                method: 'POST',
                url: process.env.VUE_APP_ROOT_API + 'web/master-distributor/update-user',
                data: data,
            })
                .then((res) => {
                    this.loading = false;
                    if (res) {
                        this.$toast.add({ severity: 'success', summary: 'Successful', detail: 'Data Successfully Saved', life: 3000, });
                        this.$store.commit('setErrors', {});
                        this.$store.commit('setErrorAdd', {});
                        this.clearForms();

                        this.$emit('submit');
                        this.$emit('close');
                    }
                })
                .catch((err) => {
                    console.log(err);
                    this.loading = false;
                    this.$store.commit('setErrorAdd', err.response.data.data);
                    this.$toast.add({ severity: 'error', summary: 'Failed', detail: 'Data Failed to Saved', life: 3000, });
                });
        },
        clearForms() {
            this.forms.mcu_id = [];
        },

        // edit
        handleCancel() {
            this.$emit('cancel')  // emit ke parent
        },
    }
}
</script>